<script>
	import { createEventDispatcher } from "svelte";

	import lookupStore from "../stores/lookupStore";

	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";
	import TextInput from "./TextInput.svelte";
	import DatePicker from "./DatePicker.svelte";
	import AutoComplete from "./AutoComplete.svelte";

	export let disabled = null;
	export let numberOfDiagnoses = 1;
	export let index = null;
	export let diagnosisType = null;
	export let diagnosis = null;

	const dispatcher = createEventDispatcher();

	const deleteRelativeDiagnosis = () => {
		dispatcher("delete-diagnosis");
	};
</script>

<div class="diagnosis">
	<FormRow class="mt-2">
		<FormColumn cols="6">
			{#if diagnosisType === "CANCER"}
				<AutoComplete
					{disabled}
					id="disabled{index}"
					bind:value={diagnosis.diagnosisTypeName}
					placeholder="Type of cancer"
					optionList={$lookupStore.cancerCouncilType.map((c) => c.lookupName)}
				></AutoComplete>
			{:else}
				<TextInput
					required
					{disabled}
					placeholder="Type of mutation"
					bind:value={diagnosis.diagnosisTypeName}
				/>
			{/if}
		</FormColumn>
		<FormColumn cols="6">
			<DatePicker
				required
				{disabled}
				placeholder="Date diagnosed"
				validator={true}
				start={new Date(1950, 0, 1)}
				end={new Date()}
				bind:formattedSelected={diagnosis.dateDiagnosed}
				openOnClass="calendar-icon"
			/>
		</FormColumn>
	</FormRow>

	{#if numberOfDiagnoses > 1}
		<div class="confirmation-hide">
			<button on:click|preventDefault={deleteRelativeDiagnosis} class="delete" title="Delete relative">
				<i class="fas fa-trash"></i>
			</button>
		</div>
	{/if}
</div>

<style>
	.diagnosis {
		position: relative;
	}

	.delete {
		border: none;
		outline: none;
		background-color: transparent;
		position: absolute;
		top: 10px;
		right: -36px;
		font-size: 1.1rem;
		color: var(--color-primary);
	}
</style>
